<template>
  <div>
  <el-alert type="warning" show-icon title="Under Development" description="Please review and comment." :closable="false" />

  <div class="padded">

    <el-col align="left">
      <edit-pane v-if="!hidePanel"
      ref="ep"
      prefix="Payment: ":title="form.summary"
      :is-edit="editMode"
      @save="onSave" @cancel="onCancel" @edit="onEdit" @add="onSave" />


      <el-form  :model="localData"  label-width="120px">

        <el-row :gutter="11">
          <el-col :span="12">
            <el-form-item label="Sharer" required>
              <el-select
              v-model="form.organisation_id"
              filterable
              placeholder="Enter Sharer (min 2 letters)"
              :disabled="disabled">
              <el-option
              v-for="org in this.sharers"
              :key="org.organisation.name"
              :label="org.organisation.name"
              :value="org.id">
              <span style="float: left">{{ org.organisation.name }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ org.telcoSiteId }}</span>
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <el-col :span="12">
        <el-form-item label="Invoice" required>
          <el-select
          v-model="form.invoice_id"
          filterable
          placeholder="Search Invoice No"
          :disabled="disabled">
          <el-option
          v-for="util in this.utility"
          :key="util.id"
          :label="util.invoiceNo"
          :value="util.id">
          <span style="float: left">{{ util.invoiceNo }}</span>
          <span style="float: right; color: #8492a6; font-size: 13px">{{ util.total }}</span>
        </el-option>
      </el-select>
    </el-form-item>
  </el-col>

  <el-col :span="8">
    <table class="el-table">
      <thead>
        <tr>
          <th></th>
          <th>Amount</th>
          <th v-if="showTax()" style="text-align: right;">{{taxLabel}} {{rowData.taxRate}}%</th>
        </tr>
      </thead>
      <tfoot>
        <tr>
          <th colspan="3">Non-Refundable <i style="font-weight: normal;">per sharer</i></th>
        </tr>
        <tr>
          <td>Admin Charges</td>
          <td align="right">{{formatNumber(form.adminCharges)}}</td>
          <td v-if="showTax()" align="right">{{formatNumber(adminTax)}}</td>
        </tr>
        <tr>
          <th colspan="3">Refundable <i style="font-weight: normal;">per sharer</i></th>
        </tr>
        <tr>
          <td>{{utilLabel}} Advance</td>
          <td align="right">{{formatNumber(form.advanceCharges)}}</td>
          <td v-if="showTax()" align="right">{{formatNumber(advanceTax)}}</td>
        </tr>
      </tfoot>
    </table>
  </el-col>

  <el-col :span="16">

    <el-col :span="12">
      <date-input v-model="localData.paidDate" label="Date Paid" placeholder="Paid Date" :disabled="disabled" />
    </el-col>

    <el-col :span="12">
      <el-form-item label="Reference No.">
        <el-input v-model="localData.paidRef" placeholder="Paid Ref" :disabled="disabled"></el-input>
      </el-form-item>
    </el-col>

    <el-col :span="12">
      <el-form-item label="Paid Amount">
        <el-input type="number" v-model="localData.amountPaid" :disabled="disabled">
        </el-input>
      </el-form-item>
    </el-col>

    <el-col v-if="showTax()" :span="12">
      <el-form-item label="Tax Paid">
        <el-input type="number" v-model="localData.taxPaid" :disabled="disabled">
        </el-input>
      </el-form-item>
    </el-col>

    <el-col :span="12" :offset="12">
      <el-form-item label="Total Paid">
        <b>{{totalPaid}}</b>
        </el-input>
      </el-form-item>
    </el-col>

  </el-col>
</el-row>
</el-form>

</el-col>

</div>

</div>
</template>


<script>

import {settings} from '@/components/Data'

import PostMixins from '@/mixins/PostMixins'
import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'

export default {

  mixins: [PostMixins, DateMixins, NumberMixins],

  props: {
    rowData: {
      type: Object,
      required: true
    },
    siteId: {
      type: Number
    },
    editMode: {
      type: Boolean,
      default: false
    },
    tableRef: {
      type: String,
      default: 'util-payment-table'
    },
    adding: {
      type: Boolean,
      default: false
    },
    hidePanel: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    resetData () {
      this.form.organisation_id = null
    },

    advanceValue: function (index, telco) {
      return this.site.sharers[index] && this.site.sharers[index].utilityDeposit
      ? this.taxDue(this.site.sharers[index].utilityDeposit)
      : 0.00
    },

    adjustmentValue: function (index) {
      return this.sharingValue(index) - this.advanceValue(index)
    },

    success (response) {
      this.resetData()
      this.$events.emit(this.tableRef + '-refresh-table')
    },

    onCancel () {
      this.disabled = true
    },

    onEdit () {
      this.disabled = false
    },

    onAdd () {
      this.disabled = false
      this.onSave()
    },

    onSave () {
      if (!this.form.site_id && this.localSiteId) {
        this.form.site_id = this.localSiteId
      }
/*
      this.form.issued = this.formatDateSql(this.form.issued)
      this.form.expiry = this.formatDateSql(this.form.expiry)

      this.saveForm(this, '/permits', this.form.id, this.form, this.form.summary, this.success)
      this.disabled = true
      //      this.resetData()
  */
    },

    onClose () {
      this.resetData()
      this.disabled = true
    }
  },

  computed: {
    totalPaid: function () {
      this.localData.totalPaid = Number(this.localData.amountPaid) + Number(this.localData.taxPaid)

      return this.localData.totalPaid
    },

    adminTax () {
      return this.taxDue(this.form.adminCharges)
    },

    advanceTax () {
      return this.taxDue(this.form.advanceCharges)
    }
  },

  data () {
    return {
      currency: settings.currency,
      utilLabel: this.getUtilLabel(this.rowData),
      loading: false,
      sharers: [],
      utility: [],
      disabled: false,
      taxLabel: settings.taxName,
      localData: this.rowData,
      localSiteId: (this.site_id ? this.site_id : (this.rowData.site_id && this.rowData.coverage ? this.rowData.id : this.rowData.site_id)),
      form: this.adding ? this.getTableStruct('utility_payments') : this.rowData
    }
  },

  mounted () {
    if (this.adding) {
      this.disabled = false
      delete this.form.id
    }

    if (this.rowData && this.rowData.sharers) {
      this.sharers = this.rowData.sharers
    }
// TODO: Is this necessary? Maybe a separate call to the server - Used only for the invoice number and value.
    if (this.rowData && this.rowData.utility) {
      this.utility = this.rowData.utility
    }

    this.form.site_id = (this.adding ? this.localSiteId : this.form.site_id)
    this.localSiteId = (this.siteId != null ? this.siteId : this.form.site_id)

    if (this.form.site_id && !this.localSiteId) {
      this.localSiteId = this.form.site_id
    }

//    console.log('LicenseePayment- form.site_id', this.form.site_id, 'localSiteId', this.localSiteId, 'siteId', this.siteId, 'rowData', this.rowData)
  }
}

</script>
